import type { FC } from 'react';
import type { IconComponentProps } from '@THC/components/Icon';
import { ClassifiedIcon } from '@THC/components/Icons/Classified';
import { DamageMissingTrimIcon } from '@THC/components/Icons/DamageMissingTrim';
import { VehicleFrontIcon } from '@THC/components/Icons/VehicleFront';
import { VehicleInFrameIcon } from '@THC/components/Icons/VehicleInFrame';
import { VehicleTyreTreadIcon } from '@THC/components/Icons/VehicleTyreTread';
import { VehicleWheelIcon } from '@THC/components/Icons/VehicleWheel';

interface Tab {
	Icon: FC<IconComponentProps>;
	key: string;
}

export const additionalImageKey = 'additionalImage';

export const TABS: Tab[] = [
	{
		Icon: VehicleFrontIcon,
		key: 'vehicle',
	},
	{
		Icon: ClassifiedIcon,
		key: 'documents',
	},
	{
		Icon: DamageMissingTrimIcon,
		key: 'damage',
	},
	{
		Icon: VehicleWheelIcon,
		key: 'wheels',
	},
	{
		Icon: VehicleTyreTreadIcon,
		key: 'tyres',
	},
	{
		Icon: VehicleInFrameIcon,
		key: additionalImageKey,
	},
];
